import { Profile, UserInfo } from '@luxtag/papybase';
import { merge } from 'lodash';

export const MUTATE_AUTH = 'MUTATE_AUTH';
export const MUTATE_USER = 'MUTATE_USER';
export const MUTATE_BALANCE = 'MUTATE_BALANCE';
export const MUTATE_PROFILE = 'MUTATE_PROFILE';
export const LOG_OUT = 'LOG_OUT';

interface AuthState {
    login: boolean;
    jwt: string
    user: UserInfo;
    balance: number | string;
    isLoginByEmail: boolean;
}

// initial state
const authState: AuthState = {
    login: false,
    jwt: '',
    user: {
        id: 0,
        username: '',
        email: '',
    },
    balance: 0,
    isLoginByEmail: true,
};

// getters
const getters = {
    getAuth: (state: AuthState) => state,
    isLogin: (state: AuthState) => state.login,
    getUser: (state: AuthState) => state.user,
    getProfile: (state: AuthState) => state.user.profile,
    getAddress: (state: AuthState) => state.user.address,
    getJwt: (state: AuthState) => state.jwt,
    getBalance: (state: AuthState) => state.balance,
};

// mutations
const mutations = {
    [MUTATE_AUTH](state: AuthState, payload: AuthState) {
        let theState = state;
        theState = merge(theState, payload);
    },
    [LOG_OUT](state: AuthState) {
        state.login = false;
        state.jwt = '';
        state.user = {
            id: 0,
            username: '',
            email: '',
        };
        state.balance = 0;
        state.isLoginByEmail = true;
    },
    [MUTATE_USER](state: AuthState, payload: UserInfo) {
        state.user = merge(state.user, payload);
    },
    [MUTATE_PROFILE](state: AuthState, payload: Profile) {
        state.user.profile = payload;
    },
    [MUTATE_BALANCE](state: AuthState, payload: string | number) {
        state.balance = payload;
    },
};

// actions
const actions = {
    [LOG_OUT](context: any, payload: any) {
        context.commit(LOG_OUT, payload);
    },
};

export default {
    state: authState,
    getters,
    actions,
    mutations,
};
